import { EmploymentContractType } from '@virtuslab/nfs-shared/src/schema/user';
import {
  messagesToIdentityMap,
  parsePluralMessageBlocks,
  parsePluralMessages,
} from '@virtuslab/nfs-shared/src/services/i18n/messages';
import { sharedEnumTranslations } from '@virtuslab/nfs-shared/src/services/i18n/translations/en-GB';

import messages, { enumMessage, pluralBuildingBlocks, pluralMessages } from '../messages';

import type { DefaultLanguage } from '.';

const translations: DefaultLanguage = {
  ...messagesToIdentityMap(messages),
  ...parsePluralMessages(pluralMessages),
  ...parsePluralMessageBlocks(pluralBuildingBlocks),
  ...sharedEnumTranslations,
  [enumMessage('employmentContractType', EmploymentContractType.MANAGEMENT)]: 'MC',
} as const;

export default translations;
